function FeatureSection({ feature }) {
    return (
        <div className="flex flex-col items-center gap-[6px]">
            <div className='size-4'>
                <img className='size-full' src={feature.imageLink} alt={feature.altText} />
            </div>

            <h1 className='font-semibold text-[10px] leading-[18px] text-[#000000]'>{feature.Heading}</h1>
        </div>
    )
}

function FeaturesTwo({ item }) {
    return (
        <div className='w-full grid grid-cols-4 gap-x-2 gap-y-2 px-4'>
            {item.item.featureItems.map((feature, index) => {
                return (
                    <FeatureSection 
                        key={index} 
                        feature={feature}
                    />
                )
            })}
        </div>
    );
}

export default FeaturesTwo;
